import { useContext, useEffect, useState } from "react";

import Button from "/components/Button";
import { Block } from "/components/Layout";
import CartContext from "/context/cart";
import { trackPixel } from "/utils/metaPixel";

import styles from "./ShoppingCart.module.scss";

type AccessoriesListProps = {
  nextStep: () => void;
  prevStep: () => void;
};

const ShoppingCart = ({ nextStep, prevStep }: AccessoriesListProps) => {
  const [isMobile, setIsMobile] = useState(false);

  const cart = useContext(CartContext);

  useEffect(() => {
    setIsMobile(window.innerWidth < 500);
  }, []);

  const buttonWidth = isMobile ? 140 : 180;

  // Step 2 → 3: leaving the accessories step for checkout. Comparing this count
  // against InitiateCheckout shows how many drop off on the "Utstyr" step.
  const goToCheckout = () => {
    trackPixel("CheckoutStep", {
      step: "accessories",
      num_accessories: cart.state.accessories.length
    });
    nextStep();
  };

  return (
    <div className={styles.sticky}>
      <div className={styles.header}>
        <p className={styles.price}>{cart.total} kr/mnd</p>

        <Block>
          <div className={styles.buttonGroup}>
            <Button mini onClick={prevStep} type="button" secondary>
              Tilbake
            </Button>
            <Block left={4}>
              {/*// @ts-ignore*/}
              <Button
                style={{ width: buttonWidth }}
                mini
                onClick={goToCheckout}
                type="button"
                primary
              >
                {cart.state.accessories.length === 0 ? "Hopp over" : "Neste"}
              </Button>
            </Block>
          </div>
        </Block>
      </div>
    </div>
  );
};

export default ShoppingCart;
